module.exports = __webpack_public_path__ + "assets/meeting.179a3229b5d790dcd1489de7ed8d15a2.svg";